import storeModuleFactory from 'util/storeModule/storeModuleFactory';
import endpoints from 'config/endpoints';

import {TIMEOUT_STORE, TIMESTAMP_MULTIPLY} from 'util/constants';

const
    mapFields = {
        last_run: 'lastRun'
    },
    transformEntitiesFn = item => ({
        name:    item.entity.name,
        lastRun: item.last_run ? item.last_run * TIMESTAMP_MULTIPLY : '-'
    }),
    createFetchParams = (by, pagination, sortBy, filters, period) => {
        const sort = {
            field: sortBy.field,
            desc:  sortBy.desc
        };

        let {search} = filters;

        if (sortBy.field === 'vendor') {
            sort.field = '';
            sort.desc = true;
        } else if (sortBy.field === 'costCenter') {
            sort.field = 'cost_center';
        }

        if (by === 'vendor' && search !== '') {
            search = '';
        }

        return {
            by:       by === 'costCenter' ? 'cost_center' : by,
            date:     Math.floor(period.startDate / TIMESTAMP_MULTIPLY),
            ordering: sort,
            search,
            ...pagination
        };
    };

module.exports = {
    mapFields,
    transformEntitiesFn,
    createFetchParams,
    ...storeModuleFactory({
        name:     'consolidateLastRun',
        endpoint: endpoints.consolidateLastRun.endpoint,
        timeout:  TIMEOUT_STORE.TIMEOUT_STORE_MEDIUM,
        transformEntitiesFn
    })
};



// WEBPACK FOOTER //
// ./src/modules/store/consolidateLastRun.js